import { useTheme, Box, Typography, Paper, Chip, IconButton, Tooltip } from '@mui/material';
import { Edit, Delete, DragHandle } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';


const SortableFieldRow = ({ field, onEdit, onDelete, canEdit = true, canDelete = true }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: field._id });
    const theme = useTheme();

    return (
        <Paper
            ref={setNodeRef}
            elevation={isDragging ? 4 : 1}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 1.5,
                py: 1,
                mb: 1,
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? 0.7 : 1,
                border: `1px solid ${theme.palette.neutral.deep}`,
            }}
        >
            <Box {...attributes} {...listeners} sx={{ cursor: 'grab', color: 'text.secondary', display: 'flex' }}>
                <DragHandle fontSize="small" />
            </Box>

            <Typography variant="body2" sx={{ width: 28, textAlign: 'right', color: 'text.secondary' }}>
                {field.order}
            </Typography>

            <Box flexGrow={1} display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <Typography variant="body2" fontWeight="bold">{field.label}</Typography>
                <Typography variant="caption" color="text.secondary">({field.name})</Typography>
                <Chip label={field.type} size="small" variant="outlined" sx={{ fontSize: '0.7rem' }} />
                {field.required   && <Chip label="required" size="small" color="warning" sx={{ fontSize: '0.7rem' }} />}
                {field.showInGrid && <Chip label="grid"     size="small" color="info"    sx={{ fontSize: '0.7rem' }} />}
                {field.showInForm && <Chip label="form"     size="small" color="success" sx={{ fontSize: '0.7rem' }} />}
            </Box>

            {canEdit && (
                <Tooltip title="Edit" arrow>
                    <IconButton size="small" onClick={() => onEdit(field)}>
                        <Edit fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
            {canDelete && (
                <Tooltip title="Delete" arrow>
                    <IconButton size="small" color="error" onClick={() => onDelete(field)}>
                        <Delete fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Paper>
    );
};

export default SortableFieldRow;
